import React, { Component } from 'react';
import Grid from '../../atoms/Grid';
import { SCREEN } from '../../../Common';
import NegotiationCount from '../../../container/atoms/NegotiationCountContainer';
import { LoadingStatus } from '../../../redux/reducers/LoadingStatusReducer';
import AnnotationTooltip, { AnnotationTooltipProps } from '../../molecules/AnnotationTooltip';

interface NegotiationCountListProps extends NegotiationHandler {}

export interface NegotiationHandler {
  negotiationCount: NegotiationCountListState;
  loadingStatus: LoadingStatus;
  gaSpotEvent: GASpotEventState;
  tooltipInfo: TooltipListState;
  activeTooltipId?: string;
  setActiveTooltipId?: (id: string) => void;
}

export interface GASpotEventState {
  [key: string]: string;
}

interface NegotiationCountListState {
  countNum: {
    [key: string]: number | string;
  };
}

export interface TooltipListState {
  [key: string]: AnnotationTooltipProps;
}

class NegotiationCountList extends Component<NegotiationCountListProps, NegotiationCountListState> {
  // /* 描画後 */
  // componentDidMount() {
  //   /* 初回の描画完了後に呼ばれる */
  //   /* ここではじめて実際のDOMの操作が出来る(React.findDOMNode(this)) */
  //   this.props.handleOnChangeValue();
  // }
  render() {
    const searchCountlist = [
      {
        rows: 1,
        key: 'total',
        headerTitle: 'アプローチ可能な商談',
        tooltipInfo: this.props.tooltipInfo['negotiation'],
        title: '合計',
        linkto: `${SCREEN.NEGOTIATION_SEARCH_RESULT.URL}`,
        isLinkEnable: true,
        mainCountUnit: 'negotiation',
        mainCount: this.props.negotiationCount.countNum['negotiationTotal'],
        subCount: this.props.negotiationCount.countNum['customerTotal'],
        isBrackets: true,
        gaSpotEvent: this.props.gaSpotEvent['negotiationTotal'],
      },
      {
        rows: 1,
        key: 'noneNegotiation',
        headerTitle: '更新が必要',
        title: '商談未登録の顧客',
        linkto: `${SCREEN.NEGOTIATION_SEARCH_RESULT.URL}`,
        isLinkEnable: true,
        mainCountUnit: 'customer',
        mainCount: this.props.negotiationCount.countNum['noneNegotiation'],
        subCount: '--',
        isBrackets: false,
        gaSpotEvent: this.props.gaSpotEvent['noneNegotiation'],
      },
      {
        rows: 1,
        key: 'noneProduct',
        headerTitle: '',
        title: '商品未登録の商談',
        linkto: `${SCREEN.NEGOTIATION_SEARCH_RESULT.URL}`,
        isLinkEnable: true,
        mainCountUnit: 'negotiation',
        mainCount: this.props.negotiationCount.countNum['noneProduct'],
        subCount: '--',
        isBrackets: false,
        gaSpotEvent: this.props.gaSpotEvent['noneProduct'],
      },
      {
        rows: 2,
        key: 'doing',
        headerTitle: 'レポート',
        tooltipInfo: this.props.tooltipInfo['report'],
        title: '商談中',
        linkto: `${SCREEN.UNDER_NEGOTIATION.URL}/period`,
        isLinkEnable: true,
        mainCountUnit: 'negotiation',
        mainCount: this.props.negotiationCount.countNum['doing'],
        subCount: this.props.negotiationCount.countNum['customerDoing'],
        isBrackets: true,
        gaSpotEvent: this.props.gaSpotEvent['doing'],
      },
      {
        rows: 2,
        key: 'pending',
        headerTitle: '',
        title: '長期保留',
        linkto: `${SCREEN.PENDING_NEGOTIATION.URL}/pending`,
        isLinkEnable: true,
        mainCountUnit: 'negotiation',
        mainCount: this.props.negotiationCount.countNum['pending'],
        subCount: this.props.negotiationCount.countNum['customerPending'],
        isBrackets: true,
        gaSpotEvent: this.props.gaSpotEvent['pending'],
      },
      {
        rows: 2,
        key: 'done',
        headerTitle: '',
        title: '商談終了',
        linkto: `${SCREEN.DONE_NEGOTIATION.URL}/result`,
        isLinkEnable: true,
        mainCountUnit: 'negotiation',
        mainCount: this.props.negotiationCount.countNum['done'],
        subCount: this.props.negotiationCount.countNum['customerDone'],
        isBrackets: true,
        gaSpotEvent: this.props.gaSpotEvent['done'],
      },
    ];

    return (
      <>
        <Grid>
          <Grid.Row>
            {searchCountlist
              .filter((v) => v.rows === 1)
              .map((row, index) => (
                <React.Fragment key={row.key}>
                  {/* {row.key === 'doing' && <Grid.Col col={0} colM={8} />} */}
                  <Grid.Col col={3} colM={4} colS={12} className='u-mb16' data-testid-e2e='negotiationCountList-card'>
                    <div className='headline-5 u-h2s header-title' data-testid='header-title'>
                      {row.headerTitle}
                      {row.tooltipInfo && (
                        <AnnotationTooltip
                          content={row.tooltipInfo.content}
                          url={row.tooltipInfo.url}
                          label={row.tooltipInfo.label}
                          id='negotiationTooltip'
                          activeTooltipId={this.props.activeTooltipId}
                          setActiveTooltipId={this.props.setActiveTooltipId}
                          data-testid='tooltip-info'
                        />
                      )}
                    </div>
                    <NegotiationCount
                      id={row.key}
                      title={row.title}
                      gaSpotEvent={row.gaSpotEvent}
                      mainCountUnit={row.mainCountUnit}
                      count={row.mainCount}
                      additionalCount={row.subCount}
                      isLinkEnable={row.isLinkEnable}
                      linkto={row.linkto}
                      isBrackets={row.isBrackets}
                      loadingStatus={this.props.loadingStatus}
                      data-testid='negotiation-count'
                    />
                  </Grid.Col>
                </React.Fragment>
              ))}
          </Grid.Row>
          <Grid.Row>
            {searchCountlist
              .filter((v) => v.rows === 2)
              .map((row, index) => (
                <React.Fragment key={row.key}>
                  {/* {row.key === 'doing' && <Grid.Col col={0} colM={8} />} */}
                  <Grid.Col col={3} colM={4} colS={12} className='u-mb16' data-testid-e2e='negotiationCountList-card'>
                    <div className='headline-5 u-h2s header-title' data-testid='header-title'>
                      {row.headerTitle}
                      {row.tooltipInfo && (
                        <AnnotationTooltip
                          content={row.tooltipInfo.content}
                          url={row.tooltipInfo.url}
                          label={row.tooltipInfo.label}
                          id={'reportTooltip'}
                          activeTooltipId={this.props.activeTooltipId}
                          setActiveTooltipId={this.props.setActiveTooltipId}
                          data-testid='tooltip-info'
                        />
                      )}
                    </div>
                    <NegotiationCount
                      id={row.key}
                      title={row.title}
                      gaSpotEvent={row.gaSpotEvent}
                      mainCountUnit={row.mainCountUnit}
                      count={row.mainCount}
                      additionalCount={row.subCount}
                      isLinkEnable={row.isLinkEnable}
                      linkto={row.linkto}
                      isBrackets={row.isBrackets}
                      loadingStatus={this.props.loadingStatus}
                      data-testid='negotiation-count'
                    />
                  </Grid.Col>
                </React.Fragment>
              ))}
          </Grid.Row>
        </Grid>
      </>
    );
  }
}

export default NegotiationCountList;
